import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_105: FaireProductEntity = {
  token: "starter_collection_105",
  type: "product",
  name: "Recycled Martini Glass",
  brandName: "Be Home",
  imageUrl:
    '"https://cdn.faire.com/fastly/a7a16302bb863f86f980f8b5a8c2cf4f25a6fa55578638286636267ae7354186.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=1801',
  priceDollars: 16,
  msrpDollars: 32,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
